import { OfferSearch } from "@/types";

export const DASHBOARD_DEMAND_FILTER_KEY = "dashboard-demand-filter";

export type DashboardDemandFilterPreset = OfferSearch & {
  typeClientId?: string;
};

export function saveDashboardDemandFilter(filter: DashboardDemandFilterPreset): void {
  sessionStorage.setItem(DASHBOARD_DEMAND_FILTER_KEY, JSON.stringify(filter));
}

export function readDashboardDemandFilter(): DashboardDemandFilterPreset | null {
  const raw = sessionStorage.getItem(DASHBOARD_DEMAND_FILTER_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as DashboardDemandFilterPreset;
  } catch {
    return null;
  }
}

export function clearDashboardDemandFilter(): void {
  sessionStorage.removeItem(DASHBOARD_DEMAND_FILTER_KEY);
}
